export default __webpack_public_path__ + "static/media/WakeUpCall.dc342cb1.svg";